import '../styles/MarketingPages.css';
import certificationConsultation from '../assets/certification-consultation.svg';

const BadgeIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="m12 2 1.8 2.6 3.1-.6.7 3 2.9 1.1-1.3 2.8 1.9 2.5-2.5 1.8.2 3.1-3.1.3-1.6 2.7-2.7-1.6-2.9 1.1-1-3-3-.8 1-3-2-2.4 2.5-1.8-.3-3.1 3.1-.4z" />
  </svg>
);

type AboutShowcaseSectionProps = {
  id?: string;
};

export const AboutShowcaseSection = ({ id }: AboutShowcaseSectionProps) => {
  const stats = [
    { value: '21+', label: 'Certification programs' },
    { value: '3-Step', label: 'Readiness workflow' },
    { value: 'QR', label: 'Public verification' },
  ];
  const focusAreas = [
    {
      title: 'Gap Review',
      copy: 'We identify missing documents, process gaps, and evidence needed before an audit.',
    },
    {
      title: 'Documentation',
      copy: 'We organize practical records, procedures, and certificate details for review.',
    },
    {
      title: 'Audit Readiness',
      copy: 'We help teams prepare for certification conversations with clear next steps.',
    },
  ];

  return (
    <section id={id} className="marketing-page about-page-reference about-page-showcase">
      <div className="about-showcase-shell">
        <header className="about-header-strip">
          <span className="eyebrow-pill about-eyebrow">About</span>
          <h2>
            Find Out More <span>About Us</span>
          </h2>
        </header>

        <section className="about-hero-reference">
          <div className="about-visual-stack">
            <div className="about-image-frame">
              <img src={certificationConsultation} alt="CertificationISO consultation desk" className="about-main-image" />
            </div>
          </div>

          <div className="about-copy-reference">
            <h1>
              <span>Certification</span>ISO
            </h1>
            <p className="about-intro-italic">
              CertificationISO helps organizations prepare clear documentation, understand audit
              expectations, and select certification pathways that fit their operations.
            </p>

            <div className="about-trust-row" aria-label="CertificationISO trust highlights">
              {stats.map((stat) => (
                <div key={stat.label}>
                  <strong>{stat.value}</strong>
                  <span>{stat.label}</span>
                </div>
              ))}
            </div>

            <div className="about-points">
              <div className="about-point">
                <span className="about-point-icon">
                  <BadgeIcon />
                </span>
                <p>
                  Our team of seasoned experts possesses the necessary knowledge and experience to
                  guide organizations through ISO 9001, ISO 14001, GMP, CE, and related compliance
                  requirements.
                </p>
              </div>

              <div className="about-point">
                <span className="about-point-icon">
                  <BadgeIcon />
                </span>
                <p>
                  We focus on practical steps: gap review, document preparation, process alignment,
                  and dependable support from first inquiry through certification readiness.
                </p>
              </div>
            </div>

            <div className="about-focus-grid" aria-label="CertificationISO focus areas">
              {focusAreas.map((area) => (
                <article className="about-focus-card" key={area.title}>
                  <span>{area.title}</span>
                  <p>{area.copy}</p>
                </article>
              ))}
            </div>
          </div>
        </section>
      </div>
    </section>
  );
};

const AboutPage = () => <AboutShowcaseSection />;

export default AboutPage;
